export const SEND_CONFIRMATION_CODE = 'SEND_CONFIRMATION_CODE'
export const RESEND_CONFIRMATION_CODE = 'RESEND_CONFIRMATION_CODE'
export const SIGN_IN = 'SIGN_IN'
